import { __assign, __rest } from "tslib";
import React, { useEffect, useRef } from 'react';
var VeltVideoEditor = function (props) {
    var darkMode = props.darkMode, variant = props.variant, blob = props.blob, url = props.url, annotationId = props.annotationId, recorderId = props.recorderId, rest = __rest(props, ["darkMode", "variant", "blob", "url", "annotationId", "recorderId"]);
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current && blob) {
            ref.current.blob = blob;
        }
    }, [blob]);
    return (React.createElement("velt-video-editor", __assign({ ref: ref, variant: variant, "dark-mode": darkMode ? 'true' : undefined, url: url, "annotation-id": annotationId, "recorder-id": recorderId }, rest)));
};
export default VeltVideoEditor;
